import { Slider } from '@/components/ui/slider'
import { cn } from '@/lib/utils'

const Day = ({ day, className, onClick }) => {
    return (
        <div
            onClick={onClick}
            className={cn(
                'tw:flex tw:flex-col tw:items-center tw:justify-center',
                'tw:text-xs tw:text-gray-200 tw:cursor-pointer',
                className,
            )}
        >
            <span className="tw:text-sm tw:text-gray-200">{day === 0 ? '0' : day}</span>
        </div>
    )
}

const RetencySlider = ({ value, onChange }) => {
    const dayValues = [0, 30, 60, 90, 180, 365]

    return (
        <div className="tw:w-full tw:space-y-4">
            <div className="tw:relative">
                <Slider
                    value={[value]}
                    onValueChange={(value) => onChange(value[0])}
                    min={0}
                    max={365}
                    step={1}
                    className="tw:w-full"
                />

                <div className="tw:flex tw:w-full tw:mt-2">
                    {dayValues.map((day, index) => {
                        // Calculate flex-grow based on the gap from previous value
                        // For the first item, use the value itself
                        // For others, use the gap from previous value
                        const gap = index === 0 ? day : day - dayValues[index - 1]

                        return (
                            <div
                                key={index}
                                className="tw:flex"
                                style={{
                                    flexGrow: gap,
                                    flexBasis: 0,
                                }}
                            >
                                {index === 0 ? (
                                    <Day day={day} className="tw:px-1" onClick={() => onChange(0)} />
                                ) : (
                                    <div className="tw:w-full tw:flex tw:justify-end">
                                        <Day day={day} onClick={() => onChange(day)} />
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default RetencySlider
